// extracted by mini-css-extract-plugin
module.exports = {"d1q32v1g":"d1q32v1g","icon":"icon"};